import ReactDOM from "react-dom";
import App from "App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react"
import Loader from "components/Common/Loader";

import { store, persistor, sagaMiddleware } from "store"
import rootSaga from "store/sagas";

sagaMiddleware.run(rootSaga)

const app = (
  <Provider store={store}>
    <PersistGate loading={<Loader/>} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>      
    </PersistGate>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
